import React from 'react';
import '../css/PicuHeader.css';

const PicuHeader = (props) => {
  if(props.banner === "true") {
    if(props.name) {
      return (
        <div>
          <div className='PatientHeader'>
            <div>
                <div>{props.name}</div>
                <div>{props.gender} {props.age} ({props.dob}) MRN: {props.mrn}</div>
                <div>{props.room}</div>
            </div>
          </div>
          <div className='PicuHeader'>
            <h6>{props.title}</h6>
          </div>
        </div>
      )
    } else {
      return (
        <div className='PicuHeader'>
          <div class="header-columns">
            <div><h6>{props.title}</h6></div>
          </div>
        </div>
      )
    }
  }
  return (
    <div className='PicuHeader'>
      <div class="header-columns">
        <div><h6>{props.title}</h6></div>
      </div>
    </div>
  )
}

export default PicuHeader;
